<template>
  <div class="SymbolComponent Tabs">
    <span v-if="!isULLibrary">

      <b-list-group v-for="item in selectedSymbols" :key="item.symbolId" size="sm">
        <!-- <b-list-group-item size="sm" class="d-flex justify-content-between align-items-center">{{item}}
        <b-button class="button" @click="deleteItem(item)" size="sm" :variant="variant" >{{lang.button_Remove}}</b-button>
      </b-list-group-item> -->
        <b-list-group-item class="flex-column align-items-start" :variant="variant">
          <b-row>
            <b-col cols="2">
              <div :id="'place_svg_symbol__'+item.symbolId" class="image-symbol"></div>
            </b-col>
            <b-col cols="8">
              <p>{{item.name}}</p>
              
            </b-col>
            <b-col>
              <b-button class="button" @click="deleteItem(item)" size="sm" :variant="variant">{{lang.button_Remove}}
              </b-button>
            </b-col>
          </b-row>







        </b-list-group-item>

      </b-list-group>
      <!-- <b-form-input size="sm" v-model="selectedSymbols" disabled></b-form-input>   -->
      <br>
      <p>{{lang.infotext_1}}:</p><br>
      <SymbolTableComponent :reloadTable="reloadTable" :lang="lang.table_Symbols" :data="data"></SymbolTableComponent>
      <br>
      <span v-if="!appConf.status.isLM">
        <hr>
        <p>{{lang.infotext_2}}:</p>
        <b-form inline>

          <b-form-input id="input-symbol-name" class="input-symbol-name" :state="inputStatus" size="sm"
            v-model="symbolName" :placeholder="lang.placeholder_Create" aria-describedby="input-footprint-feedback">
          </b-form-input>

          <b-form-file v-model="file" :state="Boolean(file)" :placeholder=lang.placeholder_file
            drop-placeholder="Drop file here..." class="import-file" accept=".svg" size="sm"></b-form-file>

          <b-button class="btn create-button" size="sm" @click="createSymbol" :variant="variant">
            {{lang.button_Create}}
          </b-button>
          <b-form-invalid-feedback id="input-symbol-feedback">
            {{lang.validinfo_1}}
          </b-form-invalid-feedback>



        </b-form>

      </span>

    </span>

    <b-tabs v-if="isULLibrary" v-model="tabIndex" card>

      <b-tab title="Symbols" :title-link-class="textColors" :title-item-class="textColors" active>
        <b-list-group v-for="(item) in selectedSymbols" :key="item.symbolId" size="sm">
          <!-- <b-list-group-item size="sm" class="d-flex justify-content-between align-items-center">{{item}}
        <b-button class="button" @click="deleteItem(item)" size="sm" :variant="variant" >{{lang.button_Remove}}</b-button>
      </b-list-group-item> -->
          <b-list-group-item class="flex-column align-items-start" :variant="variant">
            <b-row>
              <b-col cols="2">
                <div :id="'place_svg_symbol__'+item.symbolId" class="image-symbol"></div>
              </b-col>
              <b-col cols="8">
                <p>{{item.name}}</p>
              </b-col>
              <b-col>
                <b-button class="button" @click="deleteItem(item)" size="sm" :variant="variant">{{lang.button_Remove}}
                </b-button>
              </b-col>
            </b-row>

          </b-list-group-item>

        </b-list-group>

        
        <!-- <b-form-input size="sm" v-model="selectedSymbols" disabled></b-form-input>   -->
        <br>
        <p>{{lang.infotext_1}}:</p><br>
        <SymbolTableComponent :reloadTable="reloadTable" :lang="lang.table_Symbols"  :data="data"></SymbolTableComponent>
        <br>
        <span v-if="!appConf.status.isLM">
          <hr>
          <p>{{lang.infotext_2}}:</p>
          <b-form inline>

            <b-form-input id="input-symbol-name" class="input-symbol-name" :state="inputStatus" size="sm"
              v-model="symbolName" :placeholder="lang.placeholder_Create" aria-describedby="input-footprint-feedback">
            </b-form-input>

            <b-form-file v-model="file" :state="Boolean(file)" :placeholder=lang.placeholder_file
              drop-placeholder="Drop file here..." class="import-file" accept=".svg" size="sm"></b-form-file>

            <b-button class="btn create-button" size="sm" @click="createSymbol" :variant="variant">
              {{lang.button_Create}}
            </b-button>
            <b-form-invalid-feedback id="input-symbol-feedback">
              {{lang.validinfo_1}}
            </b-form-invalid-feedback>



          </b-form>

        </span>
      </b-tab>
      <b-tab title="Ultra Librarian" :title-link-class="textColors" :title-item-class="textColors">
        <LibraryULComponent :item="part" :lang="lang.LibraryUL" :source="source"></LibraryULComponent>
      </b-tab>
    </b-tabs>




  </div>
</template>

<script>

import SymbolTableComponent from "@/components/shared/SymbolTableComponent"
import LibraryULComponent from "@/components/shared/LibraryULComponent"
import LibraryTypes from '@/constants/LibraryTypes'
import PartPropertiesType from '@/constants/PartPropertiesType'
import { mapGetters } from 'vuex'

export default {
  name: 'SymbolComponent',
  components: {
    SymbolTableComponent,
    LibraryULComponent
  },
  props:{
    lang: Object,
    selected: String,
    data: Object
    
  },
  data () {
    return {
      symbolName: "",
      inputStatus: null,
      reloadTable: false,
      file: null,
      isMPN: false,
      isULLibrary: false,
      mpn: {},
      
      part: {},
      tabIndex: 0,
    }
  },
  computed: {
    ...mapGetters([
      'appConf',
      
    ]),
    selectedSymbols(){
      
      if (this.$store.getters.selectedSymbols.length == 0){
        return [];
      }
      return this.$store.getters.selectedSymbols;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    textColors() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return ['tabs-bg-dark', 'tabs-text-light']
      } else {
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    source() {
      return this.data.type;
    }

  },
  created() {

    this.checkIfMPN();

    let vue = this;
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteAllSelectedSymbols");

    if (this.selected == undefined ){
      this.selected = "";
    }
    let temp = this.selected.split(",");
    
    if (temp.length == 0 || temp[0] == ""){
      return [];
    }else{
      let action = '_getSymbols';
      
      if (this.data.type == LibraryTypes.HDLSYMBOL) {
        action = '_getHDLSymbols';
      }
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + action)
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){
          
          for (let i = 0, lei = temp.length; i < lei; i++){
            let symbolId = "";
            for (let j = 0, lej = result.data.length; j < lej; j++){
              if (result.data[j].name == temp[i].trim()){
                symbolId = result.data[j].symbolId;
                break;
              }

            }

            const obj = {
              name: temp[i].trim(),
              symbolId: symbolId
            }
            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_addSelectedSymbol", obj);
          }


        }

      })
      
      

    }


  },
  updated() {

   this.getSvg()
    
  },
  watch: {
    selectedSymbols:function (newVal, oldVal) {
      
      this.selectedSymbol = newVal[0];
    },
    reloadTable: function (newVal, oldVal) {
      
      this.$nextTick(function () {
        
        if (newVal == true){
          this.reloadTable = false;
        }
      })
      
      
    },
    tabIndex: function (newVal) {

      
      const objModal = {};

      if (newVal == 0) {
        objModal.ok = false
        objModal.cancel = false

      } else {
        objModal.ok = true
        objModal.cancel = false
      }


      this.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)
    }
  },
  methods: {
    switchTabIndex(index) {
      
      this.tabIndex = index
      
    },
    checkIfMPN() {

      let vue = this;


      if (this.$store.getters.selectedRows.length > 0) {
        const obj = {
          partId: this.$store.getters.selectedRows[0].col___revisionId.partId
        }
        this.$store.dispatch(this.$store.getters.sectionPrefix + '_getPhysicals', obj)
          .then((result) => {
            console.log(result)
            if (result.status == "OK") {

              if (result.data.length > 0) {
                vue.isULLibrary = true;
                vue.mpn.ManufacturerName = result.data[0].ManufacturerName
                vue.mpn.ManufacturerPartNumber = result.data[0].ManufacturerPartNumber

                let obj = {
                  manufacturerName: vue.mpn.ManufacturerName,
                  manufacturerPartNumber: vue.mpn.ManufacturerPartNumber
                }

                this.$store.dispatch(this.$store.getters.sectionPrefix + '_findPart', obj)
                  .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {

                      if (result.data != null) {
                        if (result.data.part_data != null) {
                          
                          vue.part = result.data;
                          
                        } else {
                          
                        }
                        
                        


                      } else {

                      }

                    }
                  })

              }

            }
          })
      }
      

    },
    deleteItem(item){
   
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedSymbol", item);


    },
    createSymbol(){
      
      if (this.symbolName != ""){
        let obj = {
          name: this.symbolName,
          
        }
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createSymbol", obj)
            .then((result)=>{
              console.log(result.data)
              if(result.status == "OK"){

                if (vue.file != null){
                  const objFile = {
                    type: LibraryTypes.PART, //todo to check
                    file: vue.file
                  }

                  vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_uploadSvg", objFile)
                  .then((result)=>{
                    console.log(result.data)



                  })
                }
                


                const obj = {
                  text: this.lang.alert_success_create_symbol,
                  time: 5,
                  type: "success"
                }

                this.$store.dispatch("displayFooterAlert", obj);

                vue.symbolName = "";
                vue.inputStatus = null;
                vue.reloadTable = true;

                let input = document.getElementById("input-symbol-name");

                input.setAttribute("class", "input-symbol-name");

                
              }else{
                const obj = {
                  text: this.lang.alert_error_create_symbol,
                  time: 10,
                  type: "danger"
                }

                this.$store.dispatch("displayFooterAlert", obj);
              }
        })


      }else{
        this.inputStatus = false;
      }



    },
    getSvg(){
      
      let vue = this;

      for (let i = 0, lei = this.selectedSymbols.length; i < lei; i++){

        let type = LibraryTypes.PART
        if (this.data.type == PartPropertiesType.HDLSYMBOL) {
          type = LibraryTypes.HDLSYMBOL;
        }
        const obj = {
          type:  type,
          name: this.selectedSymbols[i].name,
          id: "place_svg_symbol__"+this.selectedSymbols[i].symbolId
        }
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSvg", obj)
        .then((result) => {
          
          if (result != null){
            
            
            let id = result.id;                          
            vue.loadSVG(result, id);
            
            
          }
        
        })
      }

      
    },
    async loadSVG(result, id){

      
      
      let place = document.getElementById(id);
   
      if (place != null) {
        if (result.noImage == false) {
          place.innerHTML = "";
          let svgData = await new Response(result).text();
          var parser = new DOMParser();
          var doc = parser.parseFromString(svgData, "image/svg+xml");
          doc.documentElement.setAttribute("width", 100);
          doc.documentElement.setAttribute("height", 100);
        
          place.appendChild(doc.documentElement);
        } else {
          place.innerHTML = "<p class=\"noimage\">No image</p>";
        }
      }
      
    },
  }
  
  
}
</script>


<style lang="scss">
    
  .create-button{
    margin-left: 10px;
  }
  .list-group-item {
    padding: 0.25rem 0.25rem !important;
    margin-top: 2px;
  }
  .import-file{
    width: 400px;
    margin-left: 10px;
   

  }
  .input-symbol-name{
    width: 200px !important;
  }
  .tile{
    max-width: 120px;
  }
  .image-symbol{
    background-color: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    margin: 5px;
    overflow: hidden;
    width: 100px;
    height: 100px;
    display: block;
    
  }
  .button{
    margin-top: 75px;
  }
  .noimage {
    color: #333;
    margin: 20px;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/SymbolComponent.vue